import type { KrCategory } from './types';

export const GROWTH_KEYWORDS_META = {
  eyebrow: 'SEO · Local Rankings',
  titleLead: 'Local keyword',
  titleAccent: 'rankings',
  description:
    "How your practice ranks on Google when a patient in your neighborhood searches for dental services. ELVA checks these rankings daily from your clinic's zip code.",
} as const;

export const KR_CATEGORIES: readonly (KrCategory | 'All')[] = [
  'All',
  'General',
  'Emergency',
  'Cosmetic',
  'Implants',
  'Spanish',
  'Specialty',
] as const;
